@let navItem = item();
@let isDisabled = navItem.isDisabled || isNavigationResolverInProgress();
<div
    class="mad-navigation-bar-item"
    [class.hide-collapsed]="navItem.hideCollapsed"
    [class.mad-navigation-bar-item--disabled]="isDisabled"
    [class]="navItem.extraClasses || ''"
>
    @if (navItem.routeSubItems || navItem.outlet) {
        @let isErrorHighlight = navItem.highlightType === SidebarItemHighlightType.Error;
        @let isWarningHighlight = navItem.highlightType === SidebarItemHighlightType.Warning;
        <a
            [routerLink]="
                [
                    navItem.routeSubItems || []
                        | translateRoute: { isAbsolute: navItem.isAbsolute, params: navItem.routeSubItemParams },
                    navItem.outlet && { outlets: navItem.outlet | translateOutlet: navItem.outletParams }
                ] | noNulls
            "
            [routerLinkActive]="navItem.routerLinkActive || 'mad--selected mad-elevation-m'"
            [routerLinkActiveOptions]="navItem.routerLinkActiveOptions || { exact: true }"
            [queryParams]="navItem.queryParams"
            [queryParamsHandling]="navItem.queryParamsHandling || ''"
            [attr.disabled]="isDisabled ? true : null"
            [class.mad--disabled]="isDisabled"
            [class.mad--attention]="isErrorHighlight"
            [class.mad--warning]="isWarningHighlight"
            [class.mad--inverted]="navItem.isInverted"
            routerLinkActive
            #rla="routerLinkActive"
            class="mad-navigation-button"
            [title]="navItem.title | translate"
            draggable="false"
        >
            @if (isErrorHighlight) {
                <sfx-badge
                    extraIconClasses="mad-icon--xs"
                    popoverText="project.action_required"
                    position="topRight"
                ></sfx-badge>
            } @else if (isWarningHighlight) {
                <sfx-badge
                    [icon]="exclamationIcon"
                    type="warning"
                    extraIconClasses="mad-icon--xs"
                    popoverText="project.pending_documents_warning_message"
                    [position]="isCollapsed() ? 'topRight' : 'centerRight'"
                ></sfx-badge>
            }
            <ng-container *ngTemplateOutlet="itemContent; context: { rla: rla }"></ng-container>
        </a>
    } @else {
        <a
            [attr.disabled]="isDisabled ? true : null"
            (click)="navItem.onClick ? navItem.onClick() : doNothing()"
            class="mad-navigation-button"
            [class.mad--disabled]="isDisabled"
            [class.mad--inverted]="navItem.isInverted"
            [class]="navItem.isActive ? 'mad--selected mad-elevation-m' : ''"
            [title]="navItem.title | translate"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }

    <ng-template
        #itemContent
        let-rla
    >
        <div class="mad-navigation-button__icon">
            @if (navItem.icon) {
                <sfx-icon
                    [icon]="isCollapsed() && navItem.collapsedIcon ? navItem.collapsedIcon : navItem.icon"
                    size="m"
                ></sfx-icon>
            } @else {
                <ng-container [ngTemplateOutlet]="navItem.iconTpl"></ng-container>
            }
            @if (navItem.outstandingNotifications; as outstandingNotifications) {
                <div
                    [class.mad-elevation-xs]="rla?.isActive || navItem.isActive"
                    class="mad-badge mad-middle mad--new mad--pulse"
                >
                    <div class="mad-badge__text">{{ outstandingNotifications }}</div>
                </div>
            }
        </div>
        <div class="mad-tool-tip mad-navigation-button__tool-tip mad--right mad--hidden">
            <div
                class="mad-tip mad--right"
                [class.mad-elevation-m]="rla?.isActive || navItem.isActive"
            >
                <div class="mad-tip__body">
                    <div class="mad-tip__text mad-no-wrap">{{ navItem.title | translate }}</div>
                </div>
                <div class="mad-tip__spike"></div>
            </div>
        </div>
        <div class="mad-navigation-button__label mad-margin-left-12">
            {{ navItem.title | translate }}

            @if (navItem.titleSuffixTpl) {
                <ng-container [ngTemplateOutlet]="navItem.titleSuffixTpl"></ng-container>
            }
        </div>
    </ng-template>
</div>
